import React, { useState, useRef, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteQuestionOpen, editQuestionText, FetchForceReroute, markUnmarkFavourite, getExpertOpenPageData, askClarificationExpert, getAnotherExpertAnswer, getQuestionDraftData } from "../../API/api";
import { handleError, replaceContentEditableText } from "../../utils";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import moment from "moment";
import { convertEpochToTimestamp } from "../../utils";
import { OverlayTrigger } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import Modal from '@mui/base/Modal';
import { handlePauseAllVideo } from "../../utils";
import FontDownloadIcon from '@mui/icons-material/FontDownload';
import Tooltip from '@mui/material/Tooltip';
import { fontFamily } from "@mui/system";
import { Button, Typography } from "@mui/material";
import { styled, } from '@mui/material/styles';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ShareIcon from '@mui/icons-material/Share';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { createTheme } from "@mui/material";
import "./OpenQuestionBoxStyles.css";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Countdown, { zeroPad } from 'react-countdown';
import { Home_PAGE_URL } from "../../Router/routerUrl";
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import Grid from '@mui/material/Grid';
import Fade from '@mui/material/Fade';
import { } from "../../Action/actions";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {
  PaperClipOutlined
} from '@ant-design/icons';






const AnswerNowButton = styled(Button)({
  backgroundColor: '#bedb39',
  borderColor: '#bedb39',
  border: '1px solid #bedb39',
  color: '#fff',
  borderRadius: '3px',
  margin: '0px 3px',
  fontFamily: 'Poppins,Lato,sans-serif',
  fontSize: '14px',
  minWidth: '150px',
  textTransform: 'capitalize',
  fontWeight: 300,
  ':hover': {
    borderColor: '#bedb39',
    border: '1px solid #bedb39',
    backgroundColor: '#fff',
    color: '#bedb39',
  }
})

const UpdateAnswerButton = styled(Button)({
  backgroundColor: '#fd7400e8;',
  borderColor: '#fd7400e8;',
  border: '1px solid #fd7400e8;',
  color: '#fff',
  borderRadius: '3px',
  margin: '0px 3px',
  fontFamily: 'Poppins,Lato,sans-serif',
  fontSize: '14px',
  minWidth: '150px',
  textTransform: 'capitalize',
  fontWeight: 300,
  ':hover': {
    borderColor: '#fd7400e8;',
    border: '1px solid ##fd7400e8;',
    backgroundColor: '#fff',
    color: '#fd7400e8;',
  }
})

const VerifyNowButton = styled(Button)({
  backgroundColor: '#fd7400e8',
  borderColor: '#fd7400e8',
  border: '1px solid #fd7400e8',
  color: '#fff',
  borderRadius: '3px',
  margin: '0px 3px',
  fontFamily: 'Poppins,Lato,sans-serif',
  fontSize: '14px',
  minWidth: '150px',
  textTransform: 'capitalize',
  fontWeight: 300,
  ':hover': {
    borderColor: '#fd7400e8',
    border: '1px solid #fd7400e8',
    backgroundColor: '#fff',
    color: '#fd7400e8',
  }
})

const DeclineButton = styled(Button)({
  backgroundColor: 'var(--dark_color_shade)',
  borderColor: 'var(--dark_color_shade)',
  border: '1px solid var(--dark_color_shade)',
  color: '#fff',
  borderRadius: '3px',
  margin: '0px 3px',
  fontFamily: 'Poppins,Lato,sans-serif',
  fontSize: '14px',
  minWidth: '150px',
  textTransform: 'capitalize',
  fontWeight: 300,
  ':hover': {
    borderColor: 'var(--dark_color_shade)',
    border: '1px solid var(--dark_color_shade)',
    backgroundColor: '#fff',
    color: 'var(--dark_color_shade)',
  }
})

const RequestClarification = styled(Button)({
  backgroundColor: 'var(--lighter_color_shade)',
  borderColor: 'var(--lighter_color_shade)',
  border: '1px solid var(--lighter_color_shade)',
  color: '#fff',
  borderRadius: '3px',
  margin: '0px 3px',
  fontFamily: 'Poppins,Lato,sans-serif',
  fontSize: '14px',
  minWidth: '150px',
  textTransform: 'capitalize',
  fontWeight: 300,
  ':hover': {
    borderColor: 'var(--lighter_color_shade)',
    border: '1px solid var(--lighter_color_shade)',
    backgroundColor: '#fff',
    color: 'var(--lighter_color_shade)',
  }
})

const RerouteButton = styled(Button)({
  backgroundColor: 'var(--darker_color_shade)',
  borderColor: 'var(--darker_color_shade)',
  border: '1px solid var(--darker_color_shade)',
  color: '#fff',
  borderRadius: '3px',
  margin: '0px 3px',
  fontFamily: 'Poppins,Lato,sans-serif',
  fontSize: '14px',
  minWidth: '150px',
  textTransform: 'capitalize',
  fontWeight: 300,
  ':hover': {
    borderColor: 'var(--darker_color_shade)',
    border: '1px solid var(--darker_color_shade)',
    backgroundColor: '#fff',
    color: 'var(--darker_color_shade)',
  }
})
export default function ExpertOpenQuestionBox(props) {
  const dispatch = useDispatch();
  const currentRoute = useLocation();
  const navigate = useNavigate();
  const { advanceFilterModalToggle, getSelectedQuestion, getkeyTagPayload, getExpertRequestUuid, getExpertData, getSelectedQuestionDataExpert, getForceRerouteUsersStatus, getDomainOfQuestion, updateAnswerTextForEditor, refreshExpertOpenTabData, updateAttachmentForEditor, questionDataForEditor, updateSubmissionTypeForEditor, recommendData, updatePageNumberExpertOpenTab, getSeekerAttachment } = bindActionCreators(Actions, dispatch);
  const [edit, setEdit] = useState(false);
  const userState = useSelector((state) => state.user);
  const [val, setVal] = useState(props.data.text || '');
  const [additional, setAdditional] = useState(props.data.additionalContext || '');
  const [clarification, setClarification] = useState(props.data.clarificationStatus);
  const [btndisable, setBtnDisable] = useState(true);
  const [clarified, setClarified] = useState(false);
  const [showScroll, setShowScroll] = useState(false);
  const expertState = useSelector((state) => state.expertOpenData);
  const [isTime, setIsTime] = useState(false);
  const [domainId, setDomainId] = useState(null);
  const [clarifyButton, setClarifyButton] = useState(false);
  const [clarificationText, setClarificationText] = useState('');
  const [isFavourite, setIsFavourite] = useState(props.data.favourite);

  const onClickNonAnswer = (flag) => {
    markUnmarkFavourite(props.data.questionUuid).then((res) => {
      if (res===undefined) return;
      // getExpertOpenData(filteredData);
      setIsFavourite(!flag)
    }).catch(err => handleError(err));
  }


  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleShare = () => {
    openModalToggle()
    setAnchorEl(null)
  }

  const Completionist = () => { return (<div style={{ opacity: "0.35" }}><span style={{ fontSize: "30px" }}>Question Expired!</span><img style={{ textAlign: "center", width: "140px" }} src={require("../../Images/timeout.png")} /> </div>) };

  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    props.data.expireSLA = props.data.expireSLA - 1;
    if (completed) {
      setIsTime(true);
      getSelectedQuestion(props.data.questionUuid);
      // element.scrollIntoView({ behaviour: 'smooth' })
      setTimeout(() => function () {
        refreshExpertOpenTabData(Math.random() * 10);
        return <Completionist />
      }, 5000);
    }
    return (
      <>
        <AccessTimeIcon sx={{ fontWeight: 'bold', fontSize: '18px', paddingRight: '3px', color: days === 0 && hours < 1 && minutes < 6 ? "red" : "green" }} />
        {/* <span className="countdown" style={{ fontSize: "14px", color: hours < 1 && minutes < 5 ? "red" : "green" }}>
          {hours > 24 && zeroPad(days)}{hours > 24 && "d"}{hours >= 1 && zeroPad(hours)}{hours >= 1 && "h"}{hours >= 1 ? ":" : null}{zeroPad(minutes)}m{hours < 1 && ":"}{hours < 1 && zeroPad(seconds)}{hours < 1 && "s"}&nbsp;left</span></>); */}
        <span style={{ fontSize: '14px', color: days === 0 && hours === 0 && minutes < 6 ? "red" : "green" }}>{days > 0 && days}{days > 0 && "d:"}{(days > 0 && hours)}{days > 0 && "h"}{(days === 0 && hours > 0 && hours)}{days === 0 && hours > 0 && "h:"}{days < 1 && minutes}{days < 1 && minutes && "m:"}{minutes < 1 && ":"}{((minutes < 60) && (days === 0)) && seconds}{((minutes < 60) && (days === 0)) && seconds && "s"}&nbsp;left</span>
      </>
    )
  };

  function secondsToDhms(seconds) {
    seconds = Number(seconds);
    var d = Math.floor(seconds / (3600 * 24));
    var h = Math.floor(seconds % (3600 * 24) / 3600);
    var m = Math.floor(seconds % 3600 / 60);
    var s = Math.floor(seconds % 60);

    var dDisplay = d > 0 ? d + (d == 1 ? " day, " : " days, ") : "";
    var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
    var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
    return dDisplay + hDisplay + mDisplay + sDisplay;
  }



  const selectTag = (tag) => {
    getkeyTagPayload(null);
    getkeyTagPayload(tag);
    if (!currentRoute.pathname.includes(`${Home_PAGE_URL}tagdata`)) {
      navigate(`${Home_PAGE_URL}tagdata`);
    }
  }

  const momentit = (stime) => {
    if (Number(Date.now()) - Number(stime) < 259200000) {
      return moment(new Date(Number(stime))).fromNow();
    } else {
      return moment(convertEpochToTimestamp(stime)).format("MMM DD, YYYY");
    }
  };


  const onChangeQuesText = (e) => {
    setVal(e.target.value);
  }

  const onChangeAddiText = (e) => {
    setAdditional(e.target.value);
  }

  const onClickMarkFavorite = (flag) => {
    let filteredData = expertState.openPageData.filter((dat) => {
      if (dat.questionUuid === props.data.questionUuid) {
        dat.favourite = !flag;
      }
      return dat;
    });
    markUnmarkFavourite(props.data.questionUuid).then((res) => {
      if (res===undefined) return;
      // getExpertOpenData(filteredData);
      setIsFavourite(!isFavourite);
    }).catch(err => handleError(err));
  }

  const successfulClarificationQuestion = () => {
    return (
      <>
        <div style={{ display: 'flex', alignItems: 'start' }}>
          <CheckCircleIcon style={{ color: '07bc0c', padding: '3px', fontSize: '32px' }} />
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span style={{ fontSize: "13px", fontWeight: "bold" }}>Great!</span>
            <span style={{ fontSize: "11px" }}>
              Your request for clarification has been forwarded to the seeker
            </span>
          </div>
        </div>
      </>
    );
  };

  const editQuestion = (que) => {
    return (
      <div class="row">
        <div class="col-lg-12">
          {props.data.clarificationStatus === true &&
            <>
              <div className="clarificationBoxToggle">
                <span className="clarificationHeading">Clarification request from expert</span>
                <span className="clarificationHeadingSubText">(Clarify question to allow an expert to provide the best answer)</span>
                <ul>
                  {props.data.clarifications.map((clar) => { return (<li className="clarificationContext"><div dangerouslySetInnerHTML={{ __html: replaceContentEditableText(clar.context) }}></div></li>) })}
                </ul></div>
            </>
          }
          {props.data.express === true && <div><OverlayTrigger delay={{ show: 250, hide: 400 }} overlay={renderTooltipUrgentQuestion} placement="bottom"><img src={require("../../Images/fire.png")}
            alt="fire"
            style={{ width: "25px", verticalAlign: "baseline" }} />
          </OverlayTrigger>
          </div>}
          <input type="text" class="form-control" value={val} onChange={(e) => onChangeQuesText(e)} />
          <h6 className="headingContent">Additional Context {props.data.clarificationStatus ? null : <>(Optional)</>}&nbsp;</h6>
          <textarea className="textArea" rows={4} value={additional} onChange={(e) => onChangeAddiText(e)}></textarea>
          <div style={{ display: 'flex' }}>{props.data.domain &&
            <span className="domainTagsToggled">
              <span className="domainTitle">Domain&nbsp;</span>
              <span className="domainTagsss">{props.data.domain}</span>
            </span>}
            &nbsp;
            {
              props.data.tags.length > 0 && <span className="domainTagsToggled"><span className="domainTitle">Tags:</span>{props.data.tags.map((ta) => { return (<span className={ta.clickable ? 'tagDisplayOpen' : 'tagDisplayOpenNonClickable'} onClick={() => selectTag(ta)}>{ta.term}</span>) })}</span>
            }
          </div>
          <div className="dateDisplay">
            <span>Asked&nbsp;</span>
            <span>{momentit(props.data.postedTimestamp)}</span>
          </div>
        </div>
      </div>
    )
  }

  const renderTooltipUrgentQuestion = (props) => (
    <Tooltip id="buttontip" {...props}>
      This is an urgent question
    </Tooltip>
  );

  const onClickModalDecline = () => {
    advanceFilterModalToggle({ bool: true, value: "expertDecline" });
    getExpertRequestUuid(props.data.expertRequestUuid);
  }

  const askSourceRender = () => {
    if (props.data.askSource === 'csv') {
      return (<span style={{ marginBottom: "0px", marginLeft: "5px" }}>&nbsp;via&nbsp;<i className="fa fa-file-excel-o" style={{ color: "#875c99" }} title="User added QA via XLS Atomizer"></i></span>)
    }
    if (props.data.askSource === 'Mobile')
      return (
        <><span>&nbsp;via&nbsp;</span><img src={require('../../Images/32x32.png')} style={{ width: "16px" }} /></>
      )
    if (props.data.askSource === 'expert-QA') {
      return (
        <span>&nbsp;via&nbsp;<i title="User added QA via Expert role" class="fa fa-user-plus" aria-hidden="true" style={{ color: "#fb7432" }}></i></span>
      )
    }
    if (props.data.askSource === 'slack') {
      return (
        <><span>&nbsp;via&nbsp;</span><img title="User searched via Slack Vizerto bot" src={require("../../Images/slack-channel.png")} style={{ width: "16px" }} /></>
      )
    }
    if (props.data.askSource === 'slackChannel') {
      return (
        <><span>&nbsp;via&nbsp;</span><img title="User asked a question on slack channel" src={require("../../Images/slack-channel.png")} style={{ width: "16px" }} /></>
      )
    }
    if (props.data.askSource === 'msteams') {
      return (
        <><span>&nbsp;via&nbsp;</span><img title="User asked a question via MS Teams" src={require("../../Images/msteams.ico")} style={{ width: "16px" }} /></>
      )
    }
    if (props.data.askSource === 'webex') {
      return (
        <><span>&nbsp;via&nbsp;</span><img title="User asked a question via Webex" src={require("../../Images/webex.jpg")} style={{ width: "16px" }} /></>
      )
    }
    if (props.data.askSource === 'webex-channel') {
      return (
        <><span>&nbsp;via&nbsp;</span><img title="User asked a question via Webex channel" src={require("../../Images/webex.jpg")} style={{ width: "16px" }} /></>
      )
    }
    if (props.data.askSource === 'email') {
      return (
        <><span>&nbsp;via&nbsp;<i title="User asked a question via Email" class="fa fa-envelope" aria-hidden="true" style={{ color: "#875c99" }}></i></span></>
      )
    }
  }

  const openModalToggle = () => {
    advanceFilterModalToggle({ bool: true, value: "expertOpen" })
    getSelectedQuestionDataExpert(props.data);
  }


  const onClickReroute = () => {
    getDomainOfQuestion(props.data.domain);
    getSelectedQuestionDataExpert(props.data.questionUuid);
    FetchForceReroute(props.data.questionUuid, domainId).then((res) => {
      if (res===undefined) return;
      if (res.data.success === true || res.data.data !== '') {
        advanceFilterModalToggle({ bool: true, value: "rerouteModal" })
        getForceRerouteUsersStatus(res.data.data);
      }
    })
  }

  const onClickClarificationButton = () => {
    setClarifyButton(!clarifyButton);
  }

  const onChangeClarificationText = (e) => {
    setClarificationText(e.target.value);
  }

  const onClickCancel = () => {
    setClarifyButton(!clarifyButton);
  }

  const onClickSubmitClarification = () => {
    const payload = {
      clarificationQuestion: clarificationText,
      questionUuidStr: props.data.questionUuid
    }
    askClarificationExpert(payload).then((res) => {
      if (res===undefined) return;
      if (res.data.success || res.data.data !== '') {
        setClarifyButton(!clarifyButton);
        // getExpertData(filteredData);
        setClarificationText('');
        // refreshExpertOpenTabData(Math.random() * 10);
        updatePageNumberExpertOpenTab(0)
        refreshExpertOpenTabData(Math.random() * 10)
        toast.success(successfulClarificationQuestion(), {
          position: toast.POSITION.TOP_RIGHT,
          icon: false
        });
      }
    })
  }

  const SeekerDropdown = () => {
    return (
      <div class="dropleft text-end">
        <div class="dropdown-toggle" type="button" style={{ fontSize: "20px" }} data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
          <div className="threedots" style={{ width: "3%", float: "right" }}><i class="fa fa-ellipsis-v" style={{ fontSize: "20px", color: "lightgray" }}></i></div>
        </div>
        <ul className="dropdown-menu" style={{ color: "#AAAAAA", cursor: "pointer" }}>
          {props.data.questionStatus === 'answered' && <><li className="iconsList" onClick={() => handleShare()} ><a class="dropdown-item" ><i class="fa fa-share-alt" style={{ paddingRight: "5px", color: props.data.sharedWith.length > 0 || props.data.sharing === true ? "green" : "#a9a9a9" }}></i>Share</a></li>
            <li><hr class="dropdown-divider" /></li></>}
          <li className="iconsList" onClick={() => onClickMarkFavorite(props.data.favourite)}><a class="dropdown-item" >
            <i
              className={`fa fa-heart ${props.data.favourite
                ? "dropdownFavoriteSelected"
                : "dropdownFavorite"
                }`}
            ></i>
            Favorite</a></li>
        </ul>
      </div>
    )
  }



  const recommendReducer = useSelector((state) => state.recommend);

  useEffect(() => {

    let i = userState.expertTopics.filter((obj) => {
      if (obj.name === props.data.domain) {
        setDomainId(obj.indexId);
        return obj;
      }
    });
  }, [])
  const onClickAnswerNow = (data) => {
    // console.log(data,'check data on click of answer now')
    getSeekerAttachment(data.seekerAttachments)
    questionDataForEditor(data);
    updateSubmissionTypeForEditor('answer');
    if (data.attachments !== undefined) {
      updateAttachmentForEditor(data.attachments);
    }
    // if(data.draftExists){
    getQuestionDraftData(data.questionUuid).then(res => {
      if (res===undefined) return;
      if (res.data.data.length > 0) {
        updateAnswerTextForEditor(res.data.data[0].answer);
        navigate('/expertHome/editor');
      } else {
        updateAnswerTextForEditor('');
        navigate('/expertHome/editor');
      }
    })
    //   }

  }

  // const CountdownWrapper = () => <Countdown renderer={renderer} date={props.data.expireSLA * 1000 + Date.now()} />;
  // const MemoCountdown = React.memo(CountdownWrapper);


  const showOtherAnswer = () => {
    let obj = {
      type: 'answered',
      quesUuid: props.data.questionUuid,
      isUrlRedirection: true
    }
    recommendData(obj);
    navigate('/expertHome/recommend');
  }

  const time = useMemo(() => {
    return (props.data.expireSLA * 1000 + Date.now())
  }, [props.data.expireSLA]);


  /* Alternate solution for countdown timer */
  const startDate = React.useRef(props.data.expireSLA * 1000 + Date.now());
  //use startDate.current in countdown date prop for initilizing the value
  /* Alternate solution for countdown timer */
  return (
    <>
      {isTime === false && expertState.isDeclined === false ? <div id="box" className="openQuestionsBox" onClick={() => handlePauseAllVideo()} style={{ marginBottom: "1%" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {edit ? <div className="col-lg-12">
            <h2>{editQuestion()}
            </h2></div> :
            <div className="titleQuestion">
              <h2>{props.data.userInitiatedCuration ? <span className="requestedUpdate" title="Requested an update for the answer">Requested Update</span> : null || props.data.express ? <Tooltip title="This is an urgent question"><span className="expressQuestionIcon">
                <img src={require("../../Images/fire.png")}
                  alt="fire"
                  style={{ width: "25px", cursor: 'pointer' }} /></span></Tooltip> : null}{props.data.questionStatus === 'answered' && <Tooltip title="View other Expert's answer" sx={{ cursor: "pointer" }}><FontDownloadIcon sx={{ marginRight: "3px", cursor: "pointer" }} onClick={() => showOtherAnswer()} style={{
                    color: "#BEDB39",
                    fontSize: "22px"
                  }} /></Tooltip>}{props.data.questionText}
              </h2>
            </div>}
          {edit ? null :
            <>
              <div style={{ display: "flex", alignItems: "flex-start" }}>
                <div> 
                  {props.data.questionStatus !== 'answered' && props.data.clarificationStatus === true && props.data.clarifications.length > 0 ? <div className="clarificationBoxExpertOpen" style={{ cursor: "pointer", marginTop: '5px' }} onClick={() => onClickClarificationButton()}><i class="fa fa-question-circle" style={{ padding: "3px" }} aria-hidden="true"></i>Clarification pending</div> : null}
                  {/* Assigned To Others Request For Clarification condition */}
                  {/* {expertState.ownRecords === false && props.data.clarificationStatus === true && props.data.questionStatus !== 'answered' && props.data.clarifications && props.data.clarifications.length > 0 ? <div className="clarificationBoxExpertOpen" style={{ cursor: "pointer", marginTop: '5px' }} onClick={() => onClickClarificationButton()}><i class="fa fa-question-circle" style={{ padding: "3px" }} aria-hidden="true"></i>Clarification pending</div>:null } */}
                  {/* Assigned To Others Request For Clarification condition end */}
                  {clarified ? <>
                    <span className="requestClarifiedText">
                      <i class="fa fa-check-circle" aria-hidden="true" style={{ padding: "2px" }}></i>
                      Request clarified
                    </span></> : null}
                </div>
                {
                  expertState.ownRecords === true &&
                  <>
                    <div style={{ marginRight: "7px" }}>
                      {/* {expertState.ownRecords === true && props.data.expireSLA > 0 && <><Countdown renderer={renderer} date={time} >
                      </Countdown></>} */}
                    </div>
                    {props.data.questionStatus === 'answered' ? <SeekerDropdown /> :
                      <>
                        <div style={{ paddingRight: "5px", paddingLeft: "5px", justifyContent: "center" }}>
                          <i
                            className={`fa fa-heart ${isFavourite
                              ? "animate-like"
                              : "dropdownFavoriteExpert"
                              }`}
                            title="Mark Favorite"
                            onClick={() => onClickNonAnswer(isFavourite)}
                          ></i>
                        </div>
                      </>}
                  </>
                }
                {
                  expertState.ownRecords === false
                  &&
                  <>
                    <div style={{ paddingRight: "5px", paddingLeft: "5px", justifyContent: "center" }}>
                      <i
                        className={`fa fa-heart ${props.data.favourite
                          ? "animate-like"
                          : "dropdownFavoriteExpertOpen"
                          }`}
                        title="Mark Favorite"
                        onClick={() => onClickMarkFavorite(props.data.favourite)}
                      ></i>
                    </div>
                  </>
                }
              </div>
            </>
          }
        </div>
        {
          edit ? null : props.data.additionalContext && <div className="col-lg-12 additionalContext">{props.data.additionalContext}</div>
        }
        {/* //Previous Design start */}
        <div style={{ display: "flex", justifyContent: 'space-between', marginBottom: "5px" }}>
          {
            <div>
              <span className="domainTitle" style={{ marginRight: "7px" }}>Asked By&nbsp;</span>
              <Tooltip TransitionComponent={Fade}
                placement="right"
                arrow title={<>{userState.geoAttributes.seekerIdentity === true && <Typography variant='h6' sx={{ fontSize: "10px" }}>{props.data.postedUserFirstName}&nbsp;{props.data.postedUserLastName}&nbsp;</Typography>}</>}><span className="domainTagsss" style={{ cursor: userState.geoAttributes.seekerIdentity === true ? "default" : null }} >{props.data.userType}</span></Tooltip>
              <span className="domainTitle" style={{ paddingLeft: "18px" }}>Asked&nbsp;&nbsp;{(momentit(props.data.questionPostedTimestamp))}</span>
              <span className="domainTitle">{askSourceRender()}</span>
            </div>}
          <div>
            {expertState.ownRecords === true && props.data.expireSLA > 0 && <><Countdown
              renderer={renderer} ref={startDate} date={time} >
            </Countdown></>}
          </div>
        </div>
        <div style={{ display: "flex", marginBottom: "5px", marginTop: "-8px" }}>
          {/* <div className="domainTitle" style={{ marginRight: "15px" }}>Domain:</div>
          <div className="domainTagsss">{props.data.domain}</div> */}
          <div>
            <span className="domainTitle" style={{ marginRight: "15px" }}>Domain&nbsp;</span>
            <span className="domainTagsss">{props.data.domain}</span>
          </div>
        </div>
        <div style={{ display: "flex", marginTop: "-3px" }}>
          {
            props.data.tags.length > 0 && <span className="domainTagsToggled" style={{ marginTop: "2px" }} ><span className="domainTitle" style={{ marginRight: "30px" }}>Tags&nbsp;</span>{props.data.tags.map((ta) => { return (<span className={ta.clickable ? 'tagDisplayOpen' : 'tagDisplayOpenNonClickable'} onClick={() => selectTag(ta)}>{ta.term}</span>) })}</span>
          }
        </div>
        {clarifyButton === false && <div className="col-lg-12 text-end">
          {userState.reroute && expertState.ownRecords === true && <RerouteButton onClick={() => onClickReroute()} ><i className="fa fa-repeat" style={{ paddingRight: '5px' }}></i>Reroute</RerouteButton>}
          {/* {props.data.clarificationStatus === false && props.data.clarifications.length ===0 && expertState.ownRecords === true && props.data.questionStatus !== 'answered' && <RequestClarification onClick={() => onClickClarificationButton()}><i className="fa fa-question-circle" style={{ paddingRight: '5px' }}></i>Request Clarification</RequestClarification>} */}
          {/* { props.data.clarificationStatus === false && props.data.questionStatus !== 'answered' && props.data.clarifications.length === 0 && <RequestClarification onClick={() => onClickClarificationButton()}><i className="fa fa-question-circle" style={{ paddingRight: '5px' }}></i>Request Clarification</RequestClarification>} */}
          {/* { props.data.questionStatus !== 'answered' && props.data.clarificationStatus === false && <RequestClarification onClick={() => onClickClarificationButton()}><i className="fa fa-question-circle" style={{ paddingRight: '5px' }}></i>Request Clarification</RequestClarification>} */}
          { props.data.questionStatus !== 'answered' && (props.data.clarificationStatus === false || props.data.clarifications.length ===0)&& <RequestClarification onClick={() => onClickClarificationButton()}><i className="fa fa-question-circle" style={{ paddingRight: '5px' }}></i>Request Clarification</RequestClarification>}
          {expertState.ownRecords === true && <DeclineButton onClick={() => onClickModalDecline()} ><i className="fa fa-times" style={{ paddingRight: '5px' }}></i>Decline</DeclineButton>}
          {((props.data.userInitiatedCuration === false && props.data.docId === undefined) && props.data.docId === undefined && <AnswerNowButton onClick={() => onClickAnswerNow(props.data)}><i className="fa fa-comment-o" style={{ paddingRight: '5px' }}></i>Answer Now</AnswerNowButton>)}
          {((props.data.userInitiatedCuration === true && props.data.docId === undefined) && props.data.docId === undefined && <UpdateAnswerButton onClick={() => onClickAnswerNow(props.data)}>Update Answer</UpdateAnswerButton>)}
          {(props.data.docId !== undefined && <VerifyNowButton onClick={() => onClickAnswerNow(props.data)}>Verify Now</VerifyNowButton>)}
        </div>}
        {
          clarifyButton === true &&
          <div className="row">
            <div className="col-md-12">
              <div className="clarifyBoxExpert">
                <span style={{ fontSize: "14px" }}></span>
                {props.data.clarifications && props.data.clarifications.length > 0 &&
                  <>
                    <ul style={{ listStyle: "square" }}>
                      {props.data.clarifications.map((cla) => {
                        return (<li style={{ color: "rgb(253, 74, 0)", fontSize: "14px" }}>{cla.context}</li>)
                      })}
                    </ul>
                  </>}
                <textarea placeholder="Ask your clarification to question here" value={clarificationText} onChange={(e) => onChangeClarificationText(e)} rows={5} style={{ width: "100%", fontSize: "14px", outline: "none", border: "1px solid lightgray" }}></textarea>
                <button className="btn-warning submitButtonExpert" disabled={clarificationText === '' ? true : false} onClick={() => onClickSubmitClarification()} >Submit</button>
                <button className="btn-warning submitButtonExpert" onClick={() => onClickCancel()} >Cancel</button>
              </div>
            </div>
          </div>
        }
      </div> :
        <div id="box" className="openQuestionsBox" onClick={() => handlePauseAllVideo()} style={{ marginBottom: "1%" }}>
          <div style={{ justifyContent: "center", display: "flex" }}>
            <Completionist />
          </div>
        </div>}
      {/* {
        expertState.isDeclined && <div id="box" className="openQuestionsBox" onClick={() => handlePauseAllVideo()} style={{ marginBottom: "1%" }}><div style={{ display: "flex", justifyContent: "center" }}><span style={{ fontSize: "30px" }}>Question Declined</span></div></div>
      } */}
    </>
  )
}



